// src/components/PackingLists/CategoryModal.js
import React from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import Modal from '../Modal';

/**
 * CategoryModal component provides UI for managing categories
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - Function to close the modal
 * @param {Array} props.categories - Available categories
 * @param {Function} props.addCategory - Function to add a new category
 * @param {Function} props.deleteCategory - Function to delete a category
 * @param {string} props.categoryInput - Current category input value
 * @param {Function} props.setCategoryInput - Function to update category input value
 * @returns {JSX.Element} Rendered component
 */
const CategoryModal = ({ 
  isOpen, 
  onClose, 
  categories, 
  addCategory, 
  deleteCategory,
  categoryInput, 
  setCategoryInput
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Manage Categories"
    >
      <div className="location-modal-content">
      <Form className="add-location-form" onSubmit={addCategory}>
        <InputGroup className="location-input-group">
          <Form.Control
            type="text"
            placeholder="New Category"
            value={categoryInput}
            onChange={(e) => setCategoryInput(e.target.value)}
            autoFocus
            required
          />
          <Button type="submit" variant="primary">Add</Button>
        </InputGroup>
      </Form>
        
        <div className="storage-locations-list">
          <h4>Current Categories:</h4>
          {categories.length === 0 ? (
            <p>No categories added yet.</p>
          ) : (
            <ul>
              {categories.map(category => (
                <li key={category.id} className="location-item">
                  <span>{category.name}</span>
                  <Button 
                    variant="outline-danger" 
                    size="sm"
                    onClick={() => deleteCategory(category.id)}
                  >
                    Delete
                  </Button>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="modal-actions">
          <Button variant="success" onClick={onClose}>
            Done
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CategoryModal;